import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../Navbar";

import Loader from "../../components/loader/Loader";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    
      <div className="min-h-screen my-[40px] max-w-5xl mx-auto px-6 sm:px-6 lg:px-8">
        {/* <Loader loading={false} /> */}
        <ToastContainer />

        <section className="text-center mb-3">
          <h1 className="text-[38px] sm:text-[48px] font-semibold text-gray-900 text-start">
            Contact Us
          </h1>
        </section>

        <section className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">
              Need Assistance? We're Here to Help!
            </h2>
            <p className="mt-2">
              At Gadgets Reborn, customer satisfaction is our top priority.
              Whether you’re seeking product support, have questions about
              your order, or want to give feedback, our team is ready to assist
              you. We offer multiple support options for your convenience, so
              you can reach us in the way that suits you best.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800">WhatsApp Support:</h2>
            <p className="mt-2">
              Need fast assistance? Our customer support team is just a message
              away. Available from 9:00 AM to 5:30 PM, Monday to Saturday (GST).
              Contact us via WhatsApp at:{" "}
              <strong>+971 55 767 6010</strong>. Quick, hassle-free, and direct
              communication at your fingertips.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800">Email Support:</h2>
            <p className="mt-2">
              For more detailed inquiries or feedback, send us an email at{" "}
              <strong>support@gadgetsreborn.com</strong>. Our team will respond
              within 24 hours to ensure your issues are promptly addressed.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800">Live Chat:</h2>
            <p className="mt-2">
              Got a quick question while browsing? Use our live chat for
              instant help. Chat with a support specialist from 9:00 AM to 5:30
              PM (GST), Monday to Saturday.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800">Our Location:</h2>
            <p className="mt-2">
              Gadgets Reborn FZ LLC <br />
              HD83C First Floor IN5 Tech Hub <br />
              Dubai Internet City, Dubai UAE
            </p>
          </div>
        </section>
      </div>
    
    </>
  );
};

export default ContactUs;
